import { gql } from 'graphql-request'

export const GET_STORY_DETAIL = gql`
  query GetBook($id: Int!) {
    book(id: $id) {
      id
      coverImgPath
      title
      writer
      cover
      writingType
      chapterType
      isTranslated
      likeCount
      viewCount
      shelfAddedCount
      commentCount
      isEpub
      isPdf
      intro
      naiinCoverImgPath
      naiinTitle
      naiinCover
      naiinLink
      status
      bookType
      chapterCount
      amountSpent
      sumCharacterDonate
      isEnded
      supporters {
        id
        displayName
        avatarImgPath
        username
      }
      penName {
        id
        firstPenName
        user {
          id
          displayName
          avatarImgPath
          writer {
            affiliation
          }
        }
      }
      rating {
        id
        name
      }
      tags {
        id
        name
      }
      category {
        id
        name
      }
      bookLink {
        id
        detail
        link
      }
      bookStory {
        name
        content
      }
    }
  }
`
